import React, { forwardRef } from 'react';
import ReactToPrint, { useReactToPrint } from 'react-to-print';

import ViewInvoice from '../InvoiceGroupPreview/ViewInvoice';
import Modal from '../../../ui/Modal';

const blockEl = 'invoices__add-note-modal';

const PrintableInvoiceModal = forwardRef((props, ref) => {
  const {
    isOpen,
    printableInvoiceData,
    printableInvoiceIds,
    setPrintModalOpen
  } = props;

  const handlePrint = useReactToPrint({
    content: () => ref.current,
  });
  const handlePrintActions = () => {
    handlePrint();
    setPrintModalOpen(false);
  };

  return (
    <Modal isOpen={isOpen} className={blockEl}>
      <Modal.Header>
        <span>Print Invoices</span>
      </Modal.Header>
      <Modal.Body>
        <div className="d-none">
          <div ref={ref} className="px-3 position-relative">
            {printableInvoiceIds.map((id, index) => (
              <div key={id} className="printable-item">
                <ViewInvoice
                  invoiceID={printableInvoiceIds[index]}
                  invoiceData={printableInvoiceData[index]}
                />
                {index < (printableInvoiceIds.length) && (
                <div className="page-break" />
                )}
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <ReactToPrint
          documentTitle="InvaluableAuctions - invoice"
          trigger={() => (
            <button
              type="button"
              className="btn btn-primary"
              aria-label="print"
              onClick={handlePrintActions()}
              id="printButton"
            >
              Start Print Job
            </button>
          )}
          content={() => ref.current}
        />
      </Modal.Footer>
    </Modal>
  );
});

export default PrintableInvoiceModal;
